var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex"},[_c('div',{attrs:{"id":"main","role":"main"}},[_c('PageSlides',{attrs:{"slides":_vm.slides}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }